import type { ReactNode } from 'react'
import { Star, Diamond } from 'lucide-react'
import { RATING_COLORS, RATING_SELECTED } from '@/lib/rating-colors'

// 実績の絞り込みで共有する定数・ヘルパー（実績ページ／トロフィー生成ダイアログで共用）

export function toDateString(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

export function getToday(): string {
  return toDateString(new Date())
}

export function getWeekStart(): string {
  const d = new Date()
  d.setDate(d.getDate() - (d.getDay() === 0 ? 6 : d.getDay() - 1))
  return toDateString(d)
}

export function getMonthStart(): string {
  const d = new Date()
  d.setDate(1)
  return toDateString(d)
}

export function getYearStart(): string {
  return toDateString(new Date(new Date().getFullYear(), 0, 1))
}

export type RatingOption = { value: number; node: ReactNode; selectedClass?: string }

export const SELF_RATING_OPTIONS: RatingOption[] = [1, 2, 3, 4, 5].map((value) => ({
  value,
  selectedClass: RATING_SELECTED.self,
  node: (
    <span className="flex gap-0.5">
      {Array.from({ length: value }).map((_, i) => (
        <Star key={i} size={13} className={RATING_COLORS.self} />
      ))}
    </span>
  ),
}))

export const AI_RATING_OPTIONS: RatingOption[] = [
  ...[1, 2, 3, 4, 5].map((value) => ({
    value,
    selectedClass: RATING_SELECTED.aiStar,
    node: (
      <span className="flex gap-0.5">
        {Array.from({ length: value }).map((_, i) => (
          <Star key={i} size={13} className={RATING_COLORS.aiStar} />
        ))}
      </span>
    ),
  })),
  ...[6, 7, 8, 9, 10].map((value) => ({
    value,
    selectedClass: RATING_SELECTED.aiDiamond,
    node: (
      <span className="flex gap-0.5">
        {Array.from({ length: value - 5 }).map((_, i) => (
          <Diamond key={i} size={13} className={RATING_COLORS.aiDiamond} />
        ))}
      </span>
    ),
  })),
]

export const SORT_OPTIONS = [
  { label: '登録日 新しい順', value: '-created_at' },
  { label: '登録日 古い順', value: 'created_at' },
  { label: '達成日 新しい順', value: '-achieved_at' },
  { label: '達成日 古い順', value: 'achieved_at' },
  { label: '自己評価 高い順', value: '-rating' },
  { label: '自己評価 低い順', value: 'rating' },
  { label: 'AI評価 高い順', value: '-ai_rating' },
  { label: 'AI評価 低い順', value: 'ai_rating' },
] as const

export const DEFAULT_ORDERING = '-created_at'

export function datePresets(): { label: string; from: string; to: string }[] {
  const today = getToday()
  return [
    { label: '全期間', from: '', to: '' },
    { label: '今週', from: getWeekStart(), to: today },
    { label: '今月', from: getMonthStart(), to: today },
    { label: '今年', from: getYearStart(), to: today },
  ]
}
